var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VisualHero',{attrs:{"image":_vm.image,"preload":"","background-color":"bg-blue-listing"}},[_vm._t("title",null,{"slot":"title"}),_vm._v(" "),_vm._t("description",null,{"slot":"description"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }